import { MatchFilter } from 'scenes/Dashboard/scenes/OrganizationsManager/duck/types'
import { ActionType, createAction, createAsyncAction } from 'typesafe-actions'

import { IdIndexedOrganizations, Organization, OrganizationData, OrganizationLocator } from './types'

export const fetchAllOrganizations = createAsyncAction(
  '/scenes/Dashboard/data/organizations/ALL_ORGANIZATIONS_FETCH_BEGIN',
  '/scenes/Dashboard/data/organizations/ALL_ORGANIZATIONS_FETCH_SUCCESS',
  '/scenes/Dashboard/data/organizations/ALL_ORGANIZATIONS_FETCH_FAILURE'
)<{ currentPage?: number; limit?: number; searchQuery?: string }, IdIndexedOrganizations, Error>()

export const fetchOneOrganization = createAsyncAction(
  '/scenes/Dashboard/data/organizations/ONE_ORGANIZATION_FETCH_BEGIN',
  '/scenes/Dashboard/data/organizations/ONE_ORGANIZATION_FETCH_SUCCESS',
  '/scenes/Dashboard/data/organizations/ONE_ORGANIZATION_FETCH_FAILURE'
)<Organization['id'], Organization, Error>()

export const setOneOrganization = createAction(
  '/scenes/Dashboard/data/organizations/SET_ONE_ORGANIZATION',
  (resolve) => (organization: Organization) => resolve(organization)
)

export const createOrganization = createAsyncAction(
  '/scenes/Dashboard/data/organizations/ORGANIZATION_CREATE_BEGIN',
  '/scenes/Dashboard/data/organizations/ORGANIZATION_CREATE_SUCCESS',
  '/scenes/Dashboard/data/organizations/ORGANIZATION_CREATE_FAILURE'
)<
  { organization: OrganizationLocator; isCreated: boolean },
  Organization,
  {
    organizationLocator: OrganizationLocator
    error: string
    isDuplicated?: boolean
  }
>()

export const updateOrganization = createAsyncAction(
  '/scenes/Dashboard/data/organizations/ORGANIZATION_UPDATE_BEGIN',
  '/scenes/Dashboard/data/organizations/ORGANIZATION_UPDATE_SUCCESS',
  '/scenes/Dashboard/data/organizations/ORGANIZATION_UPDATE_FAILURE'
)<{ organization: OrganizationData }, Organization, Error>()

export const deleteOrganizationContent = createAsyncAction(
  '/scenes/Dashboard/data/organizations/ORGANIZATION_DELETE_CONTENT_BEGIN',
  '/scenes/Dashboard/data/organizations/ORGANIZATION_DELETE_CONTENT_SUCCESS',
  '/scenes/Dashboard/data/organizations/ORGANIZATION_DELETE_CONTENT_FAILURE'
)<{ organizationId: Organization['id'] }, Organization, Error>()

export const createOrganizationMatch = createAsyncAction(
  '/scenes/Dashboard/data/organizations/CREATE_ORGANIZATION_MATCH_BEGIN',
  '/scenes/Dashboard/data/organizations/CREATE_ORGANIZATION_MATCH_SUCCESS',
  '/scenes/Dashboard/data/organizations/CREATE_ORGANIZATION_MATCH_FAILURE'
)<
  {
    organization: Organization
    matchFilter: MatchFilter | undefined
  },
  Organization,
  Error
>()

export const releaseOrganizationMatches = createAsyncAction(
  '/scenes/Dashboard/data/organizations/RELEASE_ORGANIZATIONS_MATCHES_REQUEST',
  '/scenes/Dashboard/data/organizations/RELEASE_ORGANIZATIONS_MATCHES_SUCCESS',
  '/scenes/Dashboard/data/organizations/RELEASE_ORGANIZATIONS_MATCHES_FAILURE'
)<{ organization: Organization }, undefined, Error>()

export type OrganizationAction = ActionType<
  | typeof updateOrganization
  | typeof fetchAllOrganizations
  | typeof fetchOneOrganization
  | typeof setOneOrganization
  | typeof createOrganization
  | typeof deleteOrganizationContent
  | typeof createOrganizationMatch
  | typeof releaseOrganizationMatches
>
